import { Filter } from '../../../types/main';

export const addOrRemoveFilterWithArrayValue = (filtersState: Filter[], filterKey: string, filterValue: string) => {
  let newState = [...filtersState];
  const filter: Filter | undefined = filtersState.find((item) => item.key === filterKey);
  const otherFilters: Filter[] = filtersState.filter((item) => item.key !== filterKey);

  if (filter && Array.isArray(filter.value)) {
    if (filter.value.includes(filterValue)) {
      filter.value = [...filter.value.filter((val) => val !== filterValue)];
    } else {
      filter.value = [...filter.value, filterValue];
    }

    newState = [...otherFilters, filter];
  } else {
    newState.push({ key: filterKey, value: [filterValue] });
  }

  // clear filters with empty value
  newState = newState.filter((f) => {
    return !Array.isArray(f.value) || (Array.isArray(f.value) && f.value.length);
  });
  return newState;
};

export const addOrRemoveFilterValue = (filtersState: Filter[], filterKey: string, filterValue: string) => {
  let newState = [...filtersState];
  let filter: Filter | undefined = filtersState.find((item) => item.key === filterKey);
  const otherFilters: Filter[] = filtersState.filter((item) => item.key !== filterKey);

  if (filter) {
    if (filter.value === filterValue || filterValue === '') {
      filter = undefined;
    } else {
      filter.value = filterValue;
    }

    newState = filter ? [...otherFilters, filter] : [...otherFilters];
  } else {
    newState.push({ key: filterKey, value: filterValue });
  }
  return newState;
};

export const getFilterLabel = (f: Filter, labeledFilters: Filter[]): string => labeledFilters
  .find((fl) => fl.key === f.key && (Array.isArray(f.value)
    ? f.value.includes(fl.value.toString())
    : fl.value === f.value))?.label || '';

/**
 * Split filter to several filters if value is array
 * @param filters
 * @return simpleFilters
 */
export const getFilterWithSimpleValue = (filters: Filter []): Filter[] => {
  const simpleFilters: Filter[] = [];

  filters.forEach((f) => {
    if (Array.isArray(f.value)) {
      f.value.forEach((val) => {
        simpleFilters.push({
          key: f.key,
          value: val,
          label: f.label,
        });
      });
    } else {
      simpleFilters.push(f);
    }
  });

  return simpleFilters;
};
